<template>
	<div>
		<div
			class="flex size-5 items-center justify-center rounded-full bg-gray-700 font-prenton-cond text-sm text-white"
		>
			{{ activeFiltersCount }}
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	activeFiltersCount: number;
}>();
</script>
